import { useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient, type ApiClient } from '../api';

/**
 * Hook to get an authenticated API client
 *
 * @example
 * const api = useApi();
 * const { data } = useQuery({
 *   queryKey: ['operators'],
 *   queryFn: () => api.get('/api/operators'),
 * });
 */
export function useApi(): ApiClient {
  const { getAccessTokenSilently } = useAuth0();

  return useMemo(
    () => createApiClient(getAccessTokenSilently),
    [getAccessTokenSilently]
  );
}
